import { render, staticRenderFns } from "./integralExchange.vue?vue&type=template&id=f13fbbd2&"
import script from "./integralExchange.vue?vue&type=script&lang=js&"
export * from "./integralExchange.vue?vue&type=script&lang=js&"
import style0 from "./integralExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports